import Immutable from 'immutable';
import moment from "moment";
import {getQueryUrlFromObject} from "../../utils/urlUtils";

const LOAD = 'pay/LOAD';
const LOAD_SUCCESS_CDP_REPORTS = 'pay/LOAD_SUCCESS_CDP_REPORTS';
const LOADER_PREV_PAY_SHOW = 'pay/LOADER_PREV_PAY_SHOW';
const LOADER_PREV_PAY_HIDE = 'pay/LOADER_PREV_PAY_HIDE';
const LOAD_SUCCESS_PREV_PAY_REPORT = 'pay/LOAD_SUCCESS_PREV_PAY_REPORTS';
const LOAD_SUCCESS_DR_PREV_PAY_REPORT = 'pay/LOAD_SUCCESS_DR_PREV_PAY_REPORT';
const LOAD_FAIL = 'pay/LOAD_FAIL';
const LOAD_FAIL_OTHER = 'pay/LOAD_FAIL_OTHER';
const SAVE_PARAMS = 'pay/SAVE_PARAMS'
const RESET_PAY_DATA = 'pay/RESET_PAY_DATA';
const LOAD_TIME_OFF_REQUEST_FAIL = 'pay/LOAD_TIME_OFF_REQUEST_FAIL'
const LOAD_TIME_OFF_REQUEST_SUCCESS = 'pay/LOAD_TIME_OFF_REQUEST_SUCCESS'
const LOAD_RAMP_SETUP = 'pay/LOAD_RAMP_SETUP'
const CLOSE_ERROR_MESSAGE = 'pay/CLOSE_ERROR_MESSAGE';
const LOAD_PRODUCTION_MOVE = 'pay/LOAD_PRODUCTION_MOVE'
const SAVE_PAY_BY_DOCTOR_REPORT_SUCCESS = 'pay/SAVE_PAY_BY_DOCTOR_REPORT_SUCCESS'
const SAVE_PAY_BY_DOCTOR_REPORT_FAIL = 'pay/SAVE_PAY_BY_DOCTOR_REPORT_FAIL'
const LOAD_LOCK_HISTORY_SUCCESS = 'pay/LOAD_LOCK_HISTORY_SUCCESS'
const LOAD_LOCK_HISTORY = 'pay/LOAD_LOCK_HISTORY'
const LOCK_ACTION_SUCCESS = 'pay/LOCK_ACTION_SUCCESS'
const LOAD_LOCK_HISTORY_FAIL = 'pay/LOAD_LOCK_HISTORY_FAIL'
const LOAD_SUCCESS_UDR_USER_PERMISSIONS_CDP_REPORTS = 'pay/LOAD_SUCCESS_UDR_USER_PERMISSIONS_CDP_REPORTS';
const UDR_USER_PERMISSIONS_LOAD_FAIL = 'pay/UDR_USER_PERMISSIONS_LOAD_FAIL';
const UPDATE_LOCKS_SECTIONS = 'pay/UPDATE_LOCKS_SECTIONS'
const UPDATE_LOCKS_SECTIONS_SUCCESS = 'pay/UPDATE_LOCKS_SECTIONS'
const UPDATE_LOCKS_SECTIONS_FAIL = 'pay/UPDATE_LOCKS_SECTIONS'
const LOAD_PRODUCTION_MOVE_HISTORY = 'pay/LOAD_PRODUCTION_MOVE_HISTORY'
const LOAD_DELETED_PRODUCTION_MOVES = 'pay/LOAD_DELETED_PRODUCTION_MOVES'
const LOAD_PRODUCTION_MOVE_VALIDATION = 'pay/LOAD_PRODUCTION_MOVE_VALIDATION';
const LOAD_PRODUCTION_MOVE_VALIDATION_SUCCESS = 'pay/LOAD_PRODUCTION_MOVE_VALIDATION_SUCCESS';
const LOAD_PRODMOVE_VALIDATION_HISTORY = 'pay/LOAD_PRODMOVE_VALIDATION_HISTORY';
const LOADER_SHOW = 'pay/LOADER_SHOW';
const LOADER_HIDE = 'pay/LOADER_HIDE';
const UPDATE_FINANCIAL_REMINDERS = 'pay/UPDATE_FINANCIAL_REMINDERS';
const UPDATE_CUSTOM_CONTRACT = 'pay/UPDATE_CUSTOM_CONTRACT';
const LOAD_PROVIDER_PAY_OVERRIDES = 'pay/LOAD_PROVIDER_PAY_OVERRIDES';


const initialState = Immutable.fromJS({
    isLoad: false,
    isPrePayLoad: false,
    params: {
        startDate: moment().format('YYYY-MM-01'),
        endDate: moment().endOf('month').format('YYYY-MM-DD'),
        abbr: false
    },
    scheduleData: null,
    loadErr: null,
    loadDataError: null,
    billingData: null,
    historyReportData: null,
    historyReportDataByABBR : null,
    udrUserPermissions: null,
    timeOffRequestData: [],
    rampSetup: null,
    providerPayOverrides: [],
    productionMove: null,
    loadLockHistory: false,
    lockHistory: [],
    updateLockSections: false,
    productionMoveHistory: [],
    deletedProductionMoves: [],
    productionMoveValidation: null,
    prodMoveValidationHistory: []
});

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case LOAD:
            return state
                .set('isLoad', true)
                .set('loadErr', null);

        case LOAD_RAMP_SETUP:
            return state.set('rampSetup', action.res)
        case LOAD_PROVIDER_PAY_OVERRIDES:
            return state.set('providerPayOverrides', action.res)
        case LOCK_ACTION_SUCCESS:
            return state
                .set('loadErr', action.message)

        case UPDATE_LOCKS_SECTIONS:
            return state.set('updateLockSections', true)

        case UPDATE_LOCKS_SECTIONS_SUCCESS:
            return state
                .set('updateLockSections', false)

        case UPDATE_LOCKS_SECTIONS_FAIL:
            return state
                .set('updateLockSections', false)
                .set('loadErr', action.err)

        case LOAD_PRODUCTION_MOVE:
            return state
                .set('productionMove', action.res)
                .set('isLoad', false)
                .set('loadErr', null)

        case SAVE_PARAMS:
            return state
                .set('params', action.params)

        case LOAD_SUCCESS_CDP_REPORTS:
            return state
                .set('billingData', action.res)
                .set('isLoad', false)

        case LOAD_SUCCESS_PREV_PAY_REPORT:
            return state
                .set('historyReportData', action.res)

        case LOAD_SUCCESS_DR_PREV_PAY_REPORT:
            return state
                .set('historyReportDataByABBR', action.res)

        case LOADER_PREV_PAY_SHOW:
            return state
                .set('isPrePayLoad', true)

        case LOADER_PREV_PAY_HIDE:
            return state
                .set('isPrePayLoad', false)

        case LOAD_SUCCESS_UDR_USER_PERMISSIONS_CDP_REPORTS:
            return state
                .set('udrUserPermissions', action.res)

        case UDR_USER_PERMISSIONS_LOAD_FAIL:
            return state
                .set('udrUserPermissions', null)

        case RESET_PAY_DATA:
            return state
                .set('billingData', null)

        case LOAD_FAIL:
            return state
                .set('isLoad', false)
                .set('loadErr', action.error)
                .set('loadDataError', action.error)
                .set('billingData', null)

        case CLOSE_ERROR_MESSAGE:
            return state
                .set('loadDataError', null)

        case LOAD_FAIL_OTHER:
            return state
                .set('isLoad', false)
                .set('loadErr', action.error)

        case LOAD_TIME_OFF_REQUEST_SUCCESS:
            return state
                .set('timeOffRequestData', action.res)
                .set('loadErr', null)

        case LOAD_LOCK_HISTORY:
            return state
                .set('loadLockHistory', true)

        case LOAD_LOCK_HISTORY_SUCCESS:
            return state
                .set('lockHistory', action.res)
                .set('loadLockHistory', false)
                .set('loadErr', null)

        case LOAD_LOCK_HISTORY_FAIL:
            return state
                .set('loadLockHistory', false)
                .set('loadErr', action.error)

        case LOAD_TIME_OFF_REQUEST_FAIL:
            return state
                .set('timeOffRequestData', [])
                .set('loadErr', action.error)
        case LOAD_PRODUCTION_MOVE_HISTORY:
            return state
                .set('productionMoveHistory', action.res)
                .set('isLoad', false)
                .set('loadErr', null)
        case LOAD_DELETED_PRODUCTION_MOVES:
            return state
                .set('deletedProductionMoves', action.res)
                .set('isLoad', false)
                .set('loadErr', null)
        case LOAD_PRODUCTION_MOVE_VALIDATION:
            return state
                .set('isLoad', true)
                .set('productionMoveValidation', null)
        case LOAD_PRODUCTION_MOVE_VALIDATION_SUCCESS:
            return state
                .set('isLoad', false)
                .set('productionMoveValidation', action.res)
        case LOAD_PRODMOVE_VALIDATION_HISTORY:
            return state
                .set('isLoad', false)
                .set('prodMoveValidationHistory', action.res)
                .set('loadErr', null)
        case LOADER_HIDE:
            return state
                .set('isLoad', false)

        case UPDATE_FINANCIAL_REMINDERS: {
            const {index, reminders} = action.payload;

            const billingData = Object.assign({}, action.billingData);
            const group = billingData.groupByDoctorByPractice?.[index];
            const doctor = group?.doctorPayVariables?.someValues?.Doctors?.[0];

            if (doctor) {
                const updatedDoctor = Object.assign({}, doctor, {
                    doctorFinancialNoteReminders: reminders,
                });

                const updatedDoctors = [updatedDoctor];
                const updatedSomeValues = Object.assign({}, group.doctorPayVariables.someValues, {
                    Doctors: updatedDoctors,
                });
                const updatedDoctorPayVariables = Object.assign({}, group.doctorPayVariables, {
                    someValues: updatedSomeValues,
                });
                const updatedGroup = Object.assign({}, group, {
                    doctorPayVariables: updatedDoctorPayVariables,
                });

                const updatedGroupByDoctorByPractice = [...billingData.groupByDoctorByPractice];
                updatedGroupByDoctorByPractice[index] = updatedGroup;

                const updatedBillingData = Object.assign({}, billingData, {
                    groupByDoctorByPractice: updatedGroupByDoctorByPractice,
                });

                return state.set('billingData', updatedBillingData);
            }
            break;
        }

        case UPDATE_CUSTOM_CONTRACT: {
            const { index, result } = action.payload;

            const billingData = Object.assign({}, action.billingData);
            const group = billingData.groupByDoctorByPractice?.[index];
            const doctor = group?.doctorPayVariables?.someValues?.Doctors?.[0];

            if (doctor) {
                const updatedDoctor = Object.assign({}, doctor, {
                    doctorCustomContracts: [result],
                });

                const updatedDoctors = [updatedDoctor];
                const updatedSomeValues = Object.assign({}, group.doctorPayVariables.someValues, {
                    Doctors: updatedDoctors,
                });
                const updatedDoctorPayVariables = Object.assign({}, group.doctorPayVariables, {
                    someValues: updatedSomeValues,
                });
                const updatedGroup = Object.assign({}, group, {
                    doctorPayVariables: updatedDoctorPayVariables,
                });

                const updatedGroupByDoctorByPractice = [...billingData.groupByDoctorByPractice];
                updatedGroupByDoctorByPractice[index] = updatedGroup;

                const updatedBillingData = Object.assign({}, billingData, {
                    groupByDoctorByPractice: updatedGroupByDoctorByPractice,
                });

                return state.set('billingData', updatedBillingData);
            }
            break;
        }

        default:
            return state;
    }
};


export const updateParams = (month, year) => async (dispatch, getState, api) => {
    const params = getState().get('payReports').get('params');
    if (month === 'undo' || year === 'undo') {

    } else {
        params.startDate = moment(`${year}-${month}`, 'YYYY-MM').format('YYYY-MM-01')
        params.endDate = moment(`${year}-${month}`, 'YYYY-MM').endOf('month').format('YYYY-MM-DD')
    }

    dispatch({type: SAVE_PARAMS, params: params})
}

export const hideErrorModal = () => async (dispatch, getState, api) => {
    dispatch({type: CLOSE_ERROR_MESSAGE, action: null});
}

export const getHistoryData = (type , params = '') => async (dispatch, getState, api) => {
    dispatch({type: LOADER_PREV_PAY_SHOW});
    try {
        const payParams = JSON.stringify(params);
        const data = await api.get(`payReports/getHistoryData/${type}/${payParams}`);
        if(params && params.abbr){
            dispatch({type: LOAD_SUCCESS_DR_PREV_PAY_REPORT, res: data});
        } else {
            dispatch({type: LOAD_SUCCESS_PREV_PAY_REPORT, res: data});
        }

        dispatch({type: LOADER_PREV_PAY_HIDE});
        return data;
    } catch (err) {
        dispatch({type: LOADER_PREV_PAY_HIDE});
        dispatch({type: LOAD_FAIL, error: err.message});
    }
};

export const getPreviousPayData = (params = '') => async (dispatch, getState, api) => {
    dispatch({type: LOADER_PREV_PAY_SHOW});
    try {
        if (typeof params.abbr === 'string') {
            params.abbr = [params.abbr]
        }
        const payParams = JSON.stringify(params);
        const data = await api.get(`payReports/getPreviousPayData/${payParams}`);
        dispatch({type: LOAD_SUCCESS_PREV_PAY_REPORT, res: data});
        dispatch({type: LOADER_PREV_PAY_HIDE});
        return data;
    } catch (err) {
        dispatch({type: LOADER_PREV_PAY_HIDE});
        dispatch({type: LOAD_FAIL, error: err.message});
    }
};


export const getPayData = (params = '', saved, type) => async (dispatch, getState, api) => {
    if (params) {
        dispatch({type: SAVE_PARAMS, params: JSON.parse(params)})
    }
    dispatch({type: RESET_PAY_DATA});
    dispatch({type: LOAD});

    try {
        await api.get(`payReports/getPayData/${params}?${getQueryUrlFromObject({saved, type})}`)
            .then(data => {
                if (data.message)
                    alert(data.message)
                dispatch({type: LOAD_SUCCESS_CDP_REPORTS, res: data});
            });

    } catch (err) {
        dispatch({type: LOAD_FAIL, error: err.message});
    }
};

/**
 * Fetches pay data specifically for exporting reports.
 * This action does NOT dispatch to the Redux store, preventing UI re-renders.
 * It returns a promise that resolves with the raw data.
 */
export const fetchPayDataForExport = (params = '', saved, type) => async (dispatch, getState, api) => {
    return new Promise((resolve, reject) => {
        api.get(`payReports/getPayData/${params}?${getQueryUrlFromObject({saved, type})}`)
            .then(data => {
                // Directly resolve with the data from the API response
                resolve(data);
            })
            .catch(err => {
                console.error("Failed to fetch pay data for export", err);
                reject(err);
            });
    });
};

export const getUdrPermissions = (params = '') => async (dispatch, getState, api) => {
    try {
        const data = await api.get(`payReports/getUdrPermissions/${params}`);
        dispatch({type: LOAD_SUCCESS_UDR_USER_PERMISSIONS_CDP_REPORTS, res: data});
    } catch (err) {
        dispatch({type: UDR_USER_PERMISSIONS_LOAD_FAIL, error: err.message});
    }
};

export const getTimeOffRequestData = (filters) => async (dispatch, getState, api) => {
    dispatch({type: LOAD});
    try {
        let res = await api.get(`payReports/timeOffRequests${(filters ? '/' + filters : "")}`);
        dispatch({type: LOAD_TIME_OFF_REQUEST_SUCCESS, res: res});
        return res;
    } catch (err) {
        dispatch({type: LOAD_TIME_OFF_REQUEST_FAIL, error: err.message});
    }
};

export const addRampSetup = (reportObj) => async (dispatch, getState, api) => {
    try {
        await api.post('payReports/rampSetup/add', {data: reportObj})
            .then(() => {
                api.get('payReports/rampSetup/getAll')
                    .then(data => {
                        dispatch({type: LOAD_RAMP_SETUP, res: data});
                    });
            })
        return;
    } catch (err) {
        dispatch({type: LOAD_FAIL_OTHER, error: err.message});
        return false;
    }
};


export const updateRampSetup = (reportObj) => async (dispatch, getState, api) => {
    try {
        await api.post('payReports/rampSetup/update', {data: reportObj})
            .then(() => {
                api.get('payReports/rampSetup/getAll')
                    .then(data => {
                        dispatch({type: LOAD_RAMP_SETUP, res: data});
                    });
            })
        return;
    } catch (err) {
        dispatch({type: LOAD_FAIL_OTHER, error: err.message});
        return false;
    }
};

export const deleteRampSetup = (reportObj) => async (dispatch, getState, api) => {

    try {
        await api.post('payReports/rampSetup/delete', {data: reportObj})
            .then(() => {
                api.get('payReports/rampSetup/getAll')
                    .then(data => {
                        dispatch({type: LOAD_RAMP_SETUP, res: data});
                    });
            })
        return;
    } catch (err) {
        dispatch({type: LOAD_FAIL_OTHER, error: err.message});
    }
};

export const getProviderPayOverrides = (payMonth, abbr, practiceDbName) => async (dispatch, getState, api) => {
    try {
        const query = new URLSearchParams({ payMonth, ...(abbr && { abbr }), ...(practiceDbName && { practiceDbName }) }).toString();
        const data = await api.get(`payReports/payOverride/getAll?${query}`);
        dispatch({ type: LOAD_PROVIDER_PAY_OVERRIDES, res: data });
    } catch (err) {
        dispatch({ type: LOAD_FAIL_OTHER, error: err.message });
    }
};

export const saveProviderPayOverride = (payload) => async (dispatch, getState, api) => {
    try {
        await api.post('payReports/payOverride/save', { data: payload });
        const data = await api.get(`payReports/payOverride/getAll?payMonth=${payload.pay_month}`);
        dispatch({ type: LOAD_PROVIDER_PAY_OVERRIDES, res: data });
    } catch (err) {
        dispatch({ type: LOAD_FAIL_OTHER, error: err.message });
    }
};

export const deleteProviderPayOverride = (id, payMonth) => async (dispatch, getState, api) => {
    try {
        await api.post(`payReports/payOverride/delete/${id}`, {});
        const data = await api.get(`payReports/payOverride/getAll?payMonth=${payMonth}`);
        dispatch({ type: LOAD_PROVIDER_PAY_OVERRIDES, res: data });
    } catch (err) {
        dispatch({ type: LOAD_FAIL_OTHER, error: err.message });
    }
};

export const deleteProviderPayOverrideByKey = (abbr, practiceDbName, payMonth) => async (dispatch, getState, api) => {
    try {
        await api.post('payReports/payOverride/deleteByKey', { data: { abbr, practice_db_name: practiceDbName, pay_month: payMonth } });
        const data = await api.get(`payReports/payOverride/getAll?payMonth=${payMonth}`);
        dispatch({ type: LOAD_PROVIDER_PAY_OVERRIDES, res: data });
    } catch (err) {
        dispatch({ type: LOAD_FAIL_OTHER, error: err.message });
    }
};

/**
 * Fetch pre-computed cross-report pay totals from database
 * Called by both CDP and Ortho Reports on initial load
 * Query params: startDate (YYYY-MM-01), endDate (YYYY-MM-DD) optional
 * Returns: { cdpPayDentist, cdpPayOralSurgeon, cdpPayPediatric, orthoPayTotal }
 */
export const getCrossReportTotals = (params = '') => async (dispatch, getState, api) => {
    try {
        const data = await api.get(`payReports/getCrossReportTotals${params ? '?' + params : ''}`);
        return data;
    } catch (err) {
        console.error('[getCrossReportTotals] failed:', err.message);
        return null;
    }
};

/**
 * Fetches the Total Pay figure actually sent in the last Earnings Report email for a
 * dentist/month, with no recalculation. Used by the CDP Reports "Verify Total Pay" button
 * to compare against the CDP Report, Sage Export, and Calendar totals for that same dentist.
 * Does not dispatch to the Redux store.
 */
export const getEarningsReportTotals = (abbr, startDate) => async (dispatch, getState, api) => {
    try {
        const params = JSON.stringify({ abbr, startDate });
        const data = await api.get(`payReports/getEarningsReportTotals/${params}`);
        return data;
    } catch (err) {
        console.error('[getEarningsReportTotals] failed:', err.message);
        return null;
    }
};

/**
 * Compute and persist all cross-report totals to database (called by cron job)
 * POST /payReports/computeAndSaveCrossReportTotals
 * Payload: { startDate: "YYYY-MM-01", endDate: "YYYY-MM-DD" }
 */
export const computeAndSaveCrossReportTotals = (dates) => async (dispatch, getState, api) => {
    try {
        const response = await api.post('payReports/computeAndSaveCrossReportTotals', dates);
        console.log('[computeAndSaveCrossReportTotals] saved successfully:', response);
        return response;
    } catch (err) {
        console.error('[computeAndSaveCrossReportTotals] failed:', err.message);
        return null;
    }
};

export const getRampSetup = (data) => async (dispatch, getState, api) => {

    try {
        await api.get('payReports/rampSetup/getAll')
            .then(data => {
                dispatch({type: LOAD_RAMP_SETUP, res: data});
            });

    } catch (err) {
        dispatch({type: LOAD_FAIL_OTHER, error: err.message});
    }
};

export const getProductionMove = (params) => async (dispatch, getState, api) => {
    try {
        dispatch({type: LOAD});
        await api.get(`payReports/productionMove/getAll/${params}`)
            .then(data => {
                dispatch({type: LOAD_PRODUCTION_MOVE, res: data});
            });

    } catch (err) {
        dispatch({type: LOAD_FAIL_OTHER, error: err.message});
    }
};

export const updateProductionMove = (reportObj) => async (dispatch, getState, api) => {
    try {
        dispatch({type: LOAD});
        const response = await api.post('payReports/productionMove/update', {data: reportObj})

        if (response && response.message)
            dispatch({type: LOAD_FAIL, error: response.message});

    } catch (err) {
        dispatch({type: LOAD_FAIL_OTHER, error: err.message});
        return false;
    }
};


export const validateProductionMove = (validationParams) => async (dispatch, getSate, api) => {

    try {
        dispatch({type: LOAD_PRODUCTION_MOVE_VALIDATION})
        await api.get(`productionMove/validate/${validationParams}`)
            .then(res => {
                dispatch({type: LOAD_PRODUCTION_MOVE_VALIDATION_SUCCESS, res: res})
            })
    } catch (error) {
        dispatch({type: LOAD_FAIL_OTHER, error: error})
    }

}
export const updatePayReportByProvider = (reportObj) => async (dispatch, getState, api) => {
    try {
        dispatch({type: SAVE_PAY_BY_DOCTOR_REPORT_SUCCESS});
        await api.post('payReports/savePayReportByProvider', {data: reportObj})
            .then(response => {
                alert(response.message)
            })

    } catch (err) {
        dispatch({type: SAVE_PAY_BY_DOCTOR_REPORT_FAIL, error: err.message});
        return false;
    }
};

export const updateLockSections = (lockProps) => async (dispatch, getState, api) => {
    try {
        dispatch({type: UPDATE_LOCKS_SECTIONS})
        await api.post('payReports/updateLockSections', {data: lockProps})
            .then(result => {
                dispatch({type: UPDATE_LOCKS_SECTIONS_SUCCESS, res: result})
            })
            .catch(e => dispatch({type: UPDATE_LOCKS_SECTIONS_FAIL, err: e.message}))

    } catch (e) {
        dispatch({type: UPDATE_LOCKS_SECTIONS_FAIL, err: e.message})
    }
}
export const getLockLogHistory = (reportObj) => async (dispatch, getState, api) => {
    try {
        dispatch({type: LOAD_LOCK_HISTORY})

        await api.post('payReports/getLockPayByDocLogsHistory', {data: reportObj})
            .then(res => {
                dispatch({type: LOAD_LOCK_HISTORY_SUCCESS, res: res});
            })

    } catch (err) {
        dispatch({type: LOAD_LOCK_HISTORY_FAIL, error: err.message});
        return false;
    }
};

export const selectAndDeselectLock = (reportObj) => async (dispatch, getState, api) => {
    try {
        dispatch({type: LOAD_LOCK_HISTORY});
        await api.post('payReports/toggleLockHistory', {data: reportObj})
            .then(response => {
                dispatch({type: LOAD_LOCK_HISTORY_SUCCESS, res: response})
            })

    } catch (err) {
        dispatch({type: LOAD_LOCK_HISTORY_FAIL, error: err.message});
        return false;
    }
};


export const deleteProductionMove = (reportObj) => async (dispatch, getState, api) => {

    try {
        dispatch({type: LOAD});
        return await api.post('payReports/productionMove/delete', {data: reportObj})

    } catch (err) {
        dispatch({type: LOAD_FAIL, error: err.message});
    }
};

export const getProductionMoveHistory = (productionMoveId) => async (dispatch, getState, api) => {
    try {
        dispatch({type: LOAD});
        await api.get(`payReports/productionMoveHistory?productionMoveId=${productionMoveId}`)
            .then(data => {
                dispatch({type: LOAD_PRODUCTION_MOVE_HISTORY, res: data});
            });

    } catch (err) {
        dispatch({type: LOAD_FAIL_OTHER, error: err.message});
    }
};

export const getDeletedProductionMoves = () => async (dispatch, getState, api) => {
    try {
        dispatch({type: LOAD});
        await api.get(`payReports/deletedProductionMoves`)
            .then(data => {
                dispatch({type: LOAD_DELETED_PRODUCTION_MOVES, res: data});
            });

    } catch (err) {
        dispatch({type: LOAD_FAIL_OTHER, error: err.message});
    }
};

export const getProductionMoveValidationHistory = (params) => async (dispatch, getState, api) => {
    try {
        dispatch({type: LOAD});
        await api.get(`productionMove/validationHistory/${params}`)
            .then(data => {
                dispatch({type: LOAD_PRODMOVE_VALIDATION_HISTORY, res: data});
            });

    } catch (err) {
        dispatch({type: LOAD_FAIL_OTHER, error: err.message});
    }
};

export const sendReportGox = (title, GoxList, bCareList) => async (dispatch, getState, api) => {
    dispatch({type: LOAD});
    try {
        let res = await api.post('udr/sendReportGox', {data: {title, GoxList, bCareList}});
        dispatch({type: LOADER_HIDE});
        return res;
    } catch (err) {
        dispatch({type: LOADER_HIDE});
    }
};


export const updateFinancialNoteReminderReview = (reviewDetails) => async (dispatch, getState, api) => {
    dispatch({type: LOADER_SHOW});
    const payload = {...reviewDetails}
    delete reviewDetails.doctorIndex;
    try {
        let res = await api.put(`/scheduler/financial-note-reminders/review`, {data: reviewDetails});
        dispatch({
            type: UPDATE_FINANCIAL_REMINDERS,
            billingData: getState().get('payReports').get('billingData'),
            payload: {
                index: payload.doctorIndex,
                doctorId: payload.doctorId,
                reminders: res
            }
        });
        dispatch({type: LOADER_HIDE});
        return res;
    } catch (err) {
        dispatch({type: LOADER_HIDE});
    }
};

export const saveCustomContractReview = (details) => async (dispatch, getState, api) => {
    dispatch({type: LOADER_SHOW});
    const payload = {...details};
    delete details.doctorIndex;
    try {
        let res = await api.post(`payReports/customContract/save`, {data: details});
        dispatch({
            type: UPDATE_CUSTOM_CONTRACT,
            billingData: getState().get('payReports').get('billingData'),
            payload: {
                index: payload.doctorIndex,
                result: res
            }
        });
        dispatch({type: LOADER_HIDE});
        return res;
    } catch (err) {
        dispatch({type: LOADER_HIDE});
        throw err;
    }
};

export const sendEmailPDFandCSV = (payload) => async (dispatch, getState, api) => {
    dispatch({ type: LOADER_PREV_PAY_SHOW });
    try {
        const res =  await api.post('reports/sendEmailPDFandCSV', {data: payload});
        dispatch({ type: LOADER_PREV_PAY_HIDE });
        return res;
    } catch (err) {
        dispatch({type: LOADER_PREV_PAY_HIDE});
    }
}

export const getHistoricalMetricsByProvider = (filters) => async (dispatch, getState, api) => {
    dispatch({ type: LOADER_PREV_PAY_SHOW });
    try {
        const params = JSON.stringify(filters);
        const res =  await api.get(`payReports/providerPay/historyData/${params}`);
        dispatch({ type: LOADER_PREV_PAY_HIDE });
        return res;
    } catch (err) {
        dispatch({type: LOADER_PREV_PAY_HIDE});
    }
}

// Same endpoint as getHistoricalMetricsByProvider but WITHOUT the isPrePayLoad
// loader toggle. The History Report renders its Summary modal only while
// !isPrePayLoad, so a loader-toggling fetch from inside that modal would unmount
// then remount it, re-firing the fetch in an infinite loop. Callers already
// mounted under that flag must use this variant.
export const getProviderPayHistory = (filters) => async (dispatch, getState, api) => {
    try {
        const params = JSON.stringify(filters);
        return await api.get(`payReports/providerPay/historyData/${params}`);
    } catch (err) {
        return null;
    }
}

